import { render, staticRenderFns } from "./cardList2.vue?vue&type=template&id=60036522&scoped=true"
import script from "./cardList2.vue?vue&type=script&lang=js"
export * from "./cardList2.vue?vue&type=script&lang=js"
import style0 from "./cardList2.vue?vue&type=style&index=0&id=60036522&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60036522",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60036522')) {
      api.createRecord('60036522', component.options)
    } else {
      api.reload('60036522', component.options)
    }
    module.hot.accept("./cardList2.vue?vue&type=template&id=60036522&scoped=true", function () {
      api.rerender('60036522', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/index/components/cardList2.vue"
export default component.exports